export default {
	id: 'SIMPLE_PAYWALL_1M_39_1M_9_99',
	providers: {
		paltaMap: {
			USD: 'simple_premium_1m_39_1m_9_99_usd',
			EUR: 'simple_premium_1m_39_1m_9_99_eur',
		},
		primer: 'prd_Ok8XyIn7CYWO',
	},
	model: {
		commitment_period: 0,
		intro_period_value: 1,
		intro_period_type: 'month',
		next_period_value: 1,
		next_period_type: 'month',
	},
	trial: {
		days: 30,
		priceMap: {
			USD: 9.99,
			EUR: 9.99,
		},
		originalPriceMap: {
			USD: 39,
			EUR: 39,
		},
	},
	subscription: {
		interval: 'month',
		intervalCount: 1,
		priceMap: {
			USD: 39,
			EUR: 39,
		},
	},
}
